import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/aboutus.css";
import { aboutUs } from "../../data/aboutUs";

// One icon per card — rocket for the "pushing boundaries" paragraph, compass
// for the "building communities" one — same stroke style used throughout
// this page's other icon sets.
const CARD_ICONS = [
  <path d="M14.5 9.5 19 5c.3 2.5-.3 5.4-2.5 7.5M14.5 9.5c-2 2-4 2.7-6 3-.3 2 .4 4 3 6 .3-2 1-4 3-6M14.5 9.5 10.5 5.5c-2.5-.3-5.4.3-7.5 2.5m5 8.5-2 2M9.5 15l-4 1 1-4" />,
  <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM14.5 9.5l-2 5-5 2 2-5 5-2Z" />,
];

const isReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const AboutUsLookingAhead = () => {
  const { title, paragraphs } = aboutUs.lookingAhead;
  const sectionRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;

    if (isReducedMotion()) {
      setRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          setRevealed(true);
          observer.disconnect();
        });
      },
      { threshold: 0.08 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`aboutus_ahead ${revealed ? "is-revealed" : ""}`} ref={sectionRef}>
      <div className="aboutus_ahead_inner">
        <div className="aboutus_ahead_intro">
          <span className="aboutus_ahead_blob" aria-hidden="true" />
          <h2 className="aboutus_ahead_title">{title}</h2>
        </div>

        <div className="aboutus_ahead_cards">
          {paragraphs.map((paragraph, i) => (
            <div
              className={`aboutus_ahead_card aboutus_ahead_card--${i + 1}`}
              style={{ transitionDelay: `${0.15 + i * 0.15}s` }}
              key={paragraph}
            >
              <span className="aboutus_ahead_card_icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  {CARD_ICONS[i % CARD_ICONS.length]}
                </svg>
              </span>
              <span className="aboutus_ahead_card_num">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="aboutus_ahead_card_text">{paragraph}</p>
              <Link to="/contact-us" className="aboutus_ahead_card_link">
                Get In Touch &rarr;
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUsLookingAhead;
